/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Home_query = {
    readonly metaTitle: string | null;
    readonly stopLookingForSpeakers: boolean;
    readonly becomeAPartner: boolean;
    readonly hideTopics: boolean;
    readonly " $fragmentRefs": FragmentRefs<"HeroBanner" | "SiteDescription" | "Partners" | "Donate">;
    readonly " $refType": "Home_query";
};
export type Home_query$data = Home_query;
export type Home_query$key = {
    readonly " $data"?: Home_query$data;
    readonly " $fragmentRefs": FragmentRefs<"Home_query">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Home_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "metaTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "stopLookingForSpeakers",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "becomeAPartner",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hideTopics",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HeroBanner"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SiteDescription"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Partners"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Donate"
    }
  ],
  "type": "HomePublishedContent",
  "abstractKey": null
};
(node as any).hash = 'c6fc88b53d5d7be2902a632518bb18bd';
export default node;
